import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasReportedesaldosfacturacionListaItemComponent ($q, $moment, FinanzasReportedesaldosfacturacion) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.cerrar = cerrar
  $ctrl.actualizar = actualizar

  function $onInit () {
    $ctrl.sucio = false
  }

  function cerrar () {
    $ctrl.onClose()
  }

  function actualizar () {
    let data = $ctrl.data.Detalles.filter((item) => item.iva_manual > 0 || item.isr_manual > 0)
    FinanzasReportedesaldosfacturacion.actualizar($ctrl.data.id, data)
      .then((response) => ($ctrl.sucio = false))
  }
}

module.component('finanzasReportedesaldosfacturacionListaItem', {
  controller: FinanzasReportedesaldosfacturacionListaItemComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/_/reportedesaldosfacturacion/components/lista/item/component.js